import { createContext, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentDate } from 'hooks/date-hook';
import moment from 'moment';

const CreateDayContext = createContext();

export const CreateDayProvider = ({ children }) => {
  const today = useCurrentDate();
  const { date: datePassedInFromUrl } = useParams();
  const date = datePassedInFromUrl ? new Date(...datePassedInFromUrl.split('-').map((v, i) => i === 1 ? v - 1 : Number(v))) : today;

  const [dayDetailsCreate, setDayDetailsCreate] = useState({
    addToTimeline: false,
    almanac: '',
    almanacIsHtml: false,
    bj: '',
    bloodPressureHigh: '',
    bloodPressureLow: '',
    bmi: '',
    bmr: '',
    bodyFat: '',
    bodyWater: '',
    boneMass: '',
    caloriesBurned: '',
    cholesterol: '',
    date: date,
    dateString: moment(date).format('YYYY-MM-DD'),
    description: '',
    descriptionIsHtml: false,
    dietNotes: 'PS 500',
    dietScore: '10',
    drink: '',
    exerciseHours: '',
    exerciseMinutes: '',
    exerciseNotes: '',
    extras: '',
    fatFreeBodyWeight: '',
    files: [],
    gratitude: '',
    hoursAsleep: '',
    hoursCoreSleep: '',
    hoursDeepSleep: '',
    hoursRemSleep: '',
    ironCount: '',
    massage: false,
    medical: '',
    medicalIsHtml: false,
    meditation: '',
    metabolicAge: '',
    minutesAsleep: '',
    minutesCoreSleep: '',
    minutesDeepSleep: '',
    minutesRemSleep: '',
    moneySpent: '',
    mostRecentDayRecorded: null,
    muscleMass: '',
    musicHours: '',
    musicMinutes: '',
    protein: '',
    restingHeartRate: '',
    sex: '',
    skeletalMuscle: '',
    steps: '',
    subcutaneousFat: '',
    tagsList: [],
    timelineDescription: '',
    timelineEndDate: '',
    timelineFiles: [],
    timelineIframeSrc: '',
    timelineSpanToDate: false,
    timelineSpanToPresent: false,
    timelineTagsList: [],
    timelineTitle: '',
    useDayDescriptionForTimeline: false,
    useDayFilesForTimeline: true,
    useDayTagsForTimeline: true,
    visceralFat: '',
    watched: [],
    water: '',
    weight: '',
  });

  return (
    <CreateDayContext.Provider value={{ dayDetailsCreate, setDayDetailsCreate }}>
      {children}
    </CreateDayContext.Provider>
  );
};

export const useCreateDayContext = () => useContext(CreateDayContext);
